import { render, staticRenderFns } from "./ConfiguracaoFornecedores.vue?vue&type=template&id=48a100bd&lang=pug"
import script from "./ConfiguracaoFornecedores.vue?vue&type=script&lang=js"
export * from "./ConfiguracaoFornecedores.vue?vue&type=script&lang=js"
import style0 from "./ConfiguracaoFornecedores.vue?vue&type=style&index=0&id=48a100bd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports